import * as AccountRepository from 'repositories/account';

import { AccountActionCreators } from 'actions/account';
import { FlashMessageActionCreators } from 'actions/flashMessage';
import { LayoutActionCreators } from 'actions/layout';
import { handleGenericApiError } from 'helper/error';
import { AccountEmailUpdateForm } from 'models/account';
import { Thunk } from 'models/redux';

export function updateEmail(formValue: AccountEmailUpdateForm): Thunk {
  return (dispatch) => {
    dispatch(LayoutActionCreators.showLoading.create());

    AccountRepository.updateEmail(formValue)
      .then((account) => {
        dispatch(AccountActionCreators.updateAccount.create(account));
        dispatch(FlashMessageActionCreators.show.create({
          modifier: 'success',
          text: 'action.success.account.email.update'
        }));
        dispatch(LayoutActionCreators.hideLoading.create());
      })
      .catch((e) => {
        handleGenericApiError('action.failed.account.email.update', e, dispatch);
        dispatch(LayoutActionCreators.hideLoading.create());
        console.error(e); // tslint:disable-line
      });
  };
}

export function getUnverifiedEmail(): Thunk {
  return (dispatch, getState) => {
    dispatch(LayoutActionCreators.showLoading.create());

    AccountRepository.getUnverifiedEmail()
      .then((response) => {
        if (response.email) {
          const account = getState().accountState.account;
          account.unverifiedEmail = response.email;

          dispatch(AccountActionCreators.updateAccount.create(account));
          dispatch(LayoutActionCreators.hideLoading.create());
        }
      })
      .catch((e) => {
        dispatch(LayoutActionCreators.hideLoading.create());
        console.error(e); // tslint:disable-line
      });
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/account/email.ts